{
  "documentCategory": {
    "memos": "Resident meeting documents",
    "general": "General",
    "safety": "Safety"
  },
  "errors": {
    "failedToLoad": "Document failed to load",
    "failedToOpen": "Document opening failed",
    "noDocuments": "No documents"
  }
}
